<section
  class="flex flex-col items-center gap-sm border-b border-neutral-200 pb-md mb-md">
  <lib-avatar
    [fullName]="userName()"
    [img]="userImage() ?? ''"
    [imgClass]="'size-16! rounded-full'"
    placeholderTextClass="text-lg" />

  <div class="flex flex-col text-center">
    <div
      class="text-base text-neutral-800 font-medium"
      role="menuitem"
      tabindex="-1">
      {{ userName() }}
    </div>

    <div class="text-xs text-neutral-500 font-normal">
      {{ user()?.email ?? centralUser()?.email }}
    </div>
  </div>

  <a
    id="profile_dropdown_edit_profile_button"
    [routerLink]="
      isVendor()
        ? [
            '/' +
              VENDOR_MAIN_ROUTE +
              '/' +
              VENDOR_ROUTES.ACCOUNT_SETTINGS.MAIN +
              VENDOR_ROUTES.ACCOUNT_SETTINGS.EDIT_PROFILE,
          ]
        : ['/' + EMPLOYEE_ROUTES.ACCOUNT_SETTINGS.EDIT_PROFILE]
    "
    (click)="closeDropdown()"
    class="flex items-center gap-sm py-sm px-lg text-primary-600">
    <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

    <span class="text-sm font-medium">
      {{ 'edit_profile_screen_title' | transloco }}
    </span>
  </a>
</section>
